import { render } from "./LoadingPopup.vue?vue&type=template&id=f136294e&scoped=true"
import script from "./LoadingPopup.vue?vue&type=script&lang=js"
export * from "./LoadingPopup.vue?vue&type=script&lang=js"

import "./LoadingPopup.vue?vue&type=style&index=0&id=f136294e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f136294e"]])

export default __exports__